import { create } from 'zustand'
import { subscribeWithSelector } from 'zustand/middleware'
import { produce } from 'immer'

export type Tab =
  | { tab: 'swap' }
  | { tab: 'limit'; preserveInitialPrice?: boolean }

export type TabName = Tab['tab']

type Store = {
  actions: {
    selectTab: (tab: Tab) => void
  }
  activeTab: Tab
}

export const tradeTabsStore = create<Store>()(
  subscribeWithSelector((rawStoreSet, _get) => {
    const set = (fn: (x: Store) => void) => rawStoreSet(produce(fn))

    return {
      actions: {
        selectTab: (tab: Tab) => {
          set((state) => {
            state.activeTab = tab
          })
        },
      },
      activeTab: { tab: 'swap' },
    }
  }),
)
